import { BsCloudCheck, BsTrash } from 'react-icons/bs';

const options = { year: 'numeric', month: 'numeric', day: 'numeric' };


export const conditionalStyles = [
    {
        when: row => row.operacion === 'No disponible',
        style: {
            backgroundColor: 'rgba(242, 38, 19, 0.7)',
            color: 'white'
        }
    },
    {
        when: row => row.operacion === 'Compra',
        style: {
            backgroundColor: 'rgba(63, 195, 128, 0.9)',
            color: 'black',
        }
    },
    {
        when: row => row.operacion === 'Devolución',
        style: {
            backgroundColor: 'rgba(248, 148, 6, 0.9)',
            color: 'black',
            fontWeight: 'bold'
        }
    }
]

export const customStyles = {
    rows: {
        style: {
            minHeight: '72px', // override the row height
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#debfb5',

        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};

//custom de la tabla de pedidos
export const conditionalPedidoRowStyles = [
    {
        when: row => row.estado == "PENDIENTE",
        style: {
            backgroundColor: 'rgba(242, 38, 19, 0.9)',
            color: 'white',
            '&:hover': {
                cursor: 'pointer',
            },
        },
    },
    {
        when: row => row.estado == "CONFIRMADO",
        style: {
            backgroundColor: 'rgba(0, 150, 255, 0.9)',
            color: 'white',
            '&:hover': {
                cursor: 'pointer',
            },
        },
    },
    {
        when: row => row.estado == "PRODUCCION",
        style: {
            backgroundColor: 'rgba(248, 148, 6, 0.9)',
            color: 'white',
            '&:hover': {
                cursor: 'progress',
            },
        },
    },
    {
        when: row => row.estado == "LISTO",
        style: {
            backgroundColor: 'rgba(63, 195, 128, 0.9)',
            color: 'white',
            '&:hover': {
                cursor: 'not-allowed',
            },
        },
    },
];

export function columns(deletePedido) {
    return [
        {
            name: 'Numero',
            selector: row => row.numero,
            maxWidth: '90px',
            sortable: true
        }, {
            name: 'Fecha',
            selector: row => {
                const dt = new Date(row.fecha);
                return `${dt.getUTCDate()}/${dt.getUTCMonth() + 1}/${dt.getFullYear()}`;
            },
            sortable: true,
            sortFunction: (a, b) => new Date(a.fecha) - new Date(b.fecha)
        }, {
            name: 'Descripcion',
            selector: row => row.descripcion,
            minWidth: '280px',
            wrap: true,
            format: row => row?.descripcion?.length > 250 ? `${row.descripcion.substring(0, 250)}...` : row.descripcion,
            sortable: true
        },
        {
            name: 'Estado',
            selector:row => row.estado,
            maxWidth: '120px',
            sortable: true
        }, {
            name: 'Acciones',
            button: true,
            minWidth: '50px',
            cell: (row) => (
                <>
                {row.tiendaNubeId && 
          <a rel="noreferrer noopener" target='_blank' href={`https://cocokidsrestore.mitiendanube.com/admin/v2/orders/${row.tiendaNubeId}`}>
            <BsCloudCheck />
          </a>
                }
                <BsTrash
                    onClick={() => {
                        if (
                            window.confirm(
                                `Seguro que desea eliminar el pedido de ${row.descripcion} `,
                            )
                        ) {
                            deletePedido(row._id);
                        }
                    }}
                />
                </>
            ),
        },

    ];
}

export const columnasCabecera = (quitarProducto) => [
    {
        name: 'Codigo',
        sortable: true,
        selector: (row) => {
            return `${row.UserId}.${row.codigoProducto}`;
        },
    }, {
        name: 'Descripcion',
        selector: row => row.descripcion,
        minWidth: '200px',
        wrap: true,
        sortable: true,
    },
    {
        name: 'Precio',
        selector: (row) => '$'.concat(row.precio.toFixed(2).toString()),
        sortable: true,
    }, {
        name: 'Compra/Devolución',
        selector: row => row.operacion,
        sortable: true,
    }, {
        name: 'Quitar',
        selector: (row) => {
            return row.operacion !== 'No disponible' ? <BsTrash onClick={() => {
                quitarProducto(row._id)
            }} /> : null;
        }
    }
];

export const columnasVentapie = [
    {
        name: 'Codigo',
        sortable: true,
        selector: (row) => {
            return `${row.UserId}.${row.codigoProducto}`;
        },
    },
    {
        name: 'Descripcion',
        selector: row => row.descripcion,
        minWidth: '200px',
        wrap: true,
        sortable: true,
    },
    {
        name: 'Talle',
        selector:row =>  row.talle,
        wrap: true,
        sortable: true,
    },
    {
        name: 'Precio',
        selector: (row) => '$'.concat(Number.parseFloat(row.precio).toFixed(2).toString()),
        sortable: true,
    },
];
export const columnasDevolucionPie = [
    {
        name: 'Codigo',
        sortable: true,
        selector: (row) => {
            return `${row.UserId}.${row.codigoProducto}`;
        },
    },
    {
        name: 'Descripcion',
        selector: row => row.descripcion,
        minWidth: '200px',
        wrap: true,
        sortable: true,
    },
    {
        name: 'Fecha de venta',
        selector: (row) => {
            return new Date(row.fechaVenta).toLocaleDateString('es-AR', options)
        },
        wrap: true,
        sortable: true,
    },
    {
        name: 'Precio',
        selector: (row) => '$'.concat(row.precio.toFixed(2).toString()),
        sortable: true,
    },
];

export const opcionesdepagina = {
    rowsPerPageText: 'Filas por pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todo',
}




